import { Component, OnInit, HostListener, AfterViewInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { LocalStorageService } from "./services/shared/localStorage.service";
import { } from '@types/google.analytics'
import { environment } from "../environments/environment";
import { AuthService } from './services/auth/auth.service';
import { tokenNotExpired } from "angular2-jwt";
import { Subject } from 'rxjs';
import { NotificationComponent } from './components/shared/notification.component';
import { isUndefined } from 'util';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, AfterViewInit {

  userActivity;
  userInactive: Subject<any> = new Subject();
  showNotificationComponent: boolean = true;


  constructor(public router: Router, private lsService: LocalStorageService, private authService: AuthService, private notificationComponent: NotificationComponent) {
        if (environment.useGoogleAnalytics) {
            this.router.events.subscribe(event => {
                if (event instanceof NavigationEnd) {
                    ga('set', 'page', event.urlAfterRedirects);
                    ga('send', 'pageview');
                }
            });
        }

        // check for user inactivity, and if token is expired

        this.setTimeoutForTokenExpiration();
        this.userInactive.subscribe(() => {

          if (this.authService.isAuthenticated() == true) {
            if (tokenNotExpired() == false) {
                this.authService.logout();
                this.router.navigate(['/login']);
              }
          }

        });
  }

  
    @HostListener('window:mousemove')
      refreshUserState() {
        clearTimeout(this.userActivity);
        this.setTimeoutForTokenExpiration();
      }

    @HostListener("window:scroll", [])
    onWindowScroll() {
        this.height = window.innerHeight + window.pageYOffset;
    }

    @HostListener('window:beforeunload', [])
    onBeforeUnload() {
        this.lsService.removeCurrentUser();
    }

    ngAfterViewInit() {
        //Append style as last
        var head = document.head, link = document.createElement("link");

        link.type = "text/css";
        link.rel = "stylesheet";
        link.id = "themecss";
        link.href = "theme-light.css";

        head.appendChild(link);

        this.changeTheme();
    }

  ngOnInit() {

        let o: number = +localStorage.getItem('opacity');
        if (o != null) {
            if (o >= 1) { o = 0; }
            this.opacity = o;
        } else {
            this.opacity = 0;
        }

        this.isDark = this.opacity == 0.5;

      this.height = window.innerHeight;

    }

    title = 'app';

    opacity: number = 0;
    onOpacityChanged(event: boolean) {
        this.opacity = event ? 0.5 : 0;
        localStorage.setItem('opacity', this.opacity.toString());

        this.isDark = this.opacity == 0.5;

        this.changeTheme();
    }

    height: number = 0;

    isDark: boolean = false;

    changeTheme() {
        if (this.isDark) {
            document.getElementById('themecss').setAttribute("href", "theme-dark.css");
        } else {
            document.getElementById('themecss').setAttribute("href", "theme-light.css");
        }
    }


    setTimeoutForTokenExpiration() {
      this.userActivity = setTimeout(() => this.userInactive.next(), 1000);
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/app.component.ts